import React, {useEffect, useState} from "react";
import "../../../../Dashboard/Dashboard.css";
import "../../../../Dashboard/Sidebar.js";
import Header from "../../../../layout/header";
import BottomMenu from "../../../../layout/bottomMenu";
import DashboardMenu from "../.././../../layout/dashboardMenu";
import Loader from "../../../../../Loader/Loader";

const ViewUCDLead = ({
                         getLeadById,
                         match,
                         leadById
                     }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (match?.params.id !== undefined) {
            (async () => {
                setIsLoading(true);
                await getLeadById(match?.params.id);
                setIsLoading(false);
            })();
        }
    }, []);

    return (
        <>


            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={
                                'View Dealer'
                            }
                        />

                        {/*BODY*/}

                        <div className="container-fluid">
                            {/*Heading*/}
                            <div className="d-sm-flex align-items-center justify-content-between">
                                <h1 className="h3 mb-0 text-black-100 hide">Lead</h1>
                            </div>

                            <form>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-0 bg-white">
                                            <div className="div-com-header"></div>
                                            <div className="card-body">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                value={leadById?.data?.account_name}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Business Name
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required
                                                                value={leadById?.data?.poc_name}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Owner Name
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>


                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                value={leadById?.data?.number}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Phone Number
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="email"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                value={leadById?.data?.email}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Email
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                value={leadById?.data?.address}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Address
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                value={leadById?.data?.latitude}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Latitude
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                required={true}
                                                                value={leadById?.data?.longitude}
                                                            />

                                                            <label className="large-label float-lb">
                                                                Longitude
                                                                <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        {leadById?.data?.remark &&
                                                            <div className="col-md-6 float-field ">
                                                                <input
                                                                    type="email"
                                                                    className="form-control form-control-user"
                                                                    required={true}
                                                                    value={leadById?.data?.remark}
                                                                />

                                                                <label className="large-label float-lb">
                                                                    Remark
                                                                    <i className="bi bi-asterisk astrick-icon"></i>
                                                                </label>
                                                            </div>
                                                        }

                                                        {leadById?.data?.meta_data && leadById?.data?.meta_data[0] && Object.keys(leadById?.data?.meta_data[0]).length > 0 &&
                                                            Object.keys(leadById?.data?.meta_data[0]).map((val) => {
                                                                return (
                                                                    <>
                                                                        {val !== 'state_id' && val !== 'geo_city_id' &&
                                                                            <div className="col-md-6 float-field ">
                                                                                <input
                                                                                    type="email"
                                                                                    className="form-control form-control-user"
                                                                                    required={true}
                                                                                    value={leadById?.data?.meta_data[0][val]}
                                                                                />

                                                                                <label className="large-label float-lb">
                                                                                    {val}
                                                                                    <i className="bi bi-asterisk astrick-icon"></i>
                                                                                </label>
                                                                            </div>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                        {leadById?.data?.meta_data && leadById?.data?.meta_data[0] && leadById?.data?.meta_data[0]['business_photo'] &&
                                                            leadById?.data?.meta_data[0]['business_photo'].map(val => {
                                                                return (
                                                                    <>
                                                                        <img src={val} alt={'business_doc'}
                                                                             style={{width: '200px'}}/>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <BottomMenu/>
            </div>
            {/* section ends */}
        </>
    );
};
export default ViewUCDLead;
